import React, { useState, useEffect } from "react";
import "./../studentComponents/ordersPage.css"; 

const OrderPage = () => {
  // State to store the fetched transaction data
  const [transactions, setTransactions] = useState([]);
  const [loading, setLoading] = useState(true);  // To handle loading state
  const [error, setError] = useState(null);  // To handle any errors

  // Fetching transaction data from the backend
  useEffect(() => {
    const fetchTransactionData = async () => {
      try {
        // Use the correct API endpoint
        const response = await fetch("https://admindashboard.clns.in/api/dashboard/student-transactions/"); 

        if (!response.ok) {
          throw new Error("Failed to fetch data");
        }

        const data = await response.json();

        if (data.transactions && Array.isArray(data.transactions)) {
          setTransactions(data.transactions);  // Set the transactions array to state
        } else {
          setError("No transaction data available");
        }
      } catch (err) {
        setError(err.message);  // Set error message in case of failure
      } finally {
        setLoading(false);  // Stop loading after the request is finished
      }
    };

    fetchTransactionData();
  }, []);  // Empty dependency array means this effect runs once after the initial render

  // Helper function to format date
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', { 
      year: 'numeric', 
      month: 'short', 
      day: 'numeric' 
    });
  };

  // Helper function to format address
  const formatAddress = (address) => {
    if (!address) return "N/A";
    return `${address.building}, ${address.street}, ${address.state} - ${address.pincode}`;
  };

  // Render the table if not loading, otherwise show loading message
  const renderTable = () => {
    if (loading) {
      return <div className="loading-container">Loading...</div>;
    }

    if (error) {
      return <div className="error-container">Error: {error}</div>;
    }

    if (transactions.length === 0) {
      return <div className="no-data-container">No transactions found.</div>;
    }

    return (
      <div className="transactions-container">
        <h2>Your Order History</h2>
        <table className="transactions-table">
          <thead>
            <tr>
              <th>Order Date</th>
              <th>Payment ID</th>
              <th>Status</th>
              <th>Books</th>
              <th>Quantity</th>
              <th>Amount</th>
              <th>Shipping Address</th>
            </tr>
          </thead>
          <tbody>
            {transactions.map((transaction) => (
              <tr key={transaction.payment_id} className={`status-${transaction.payment_status.toLowerCase()}`}>
                <td>{formatDate(transaction.transaction_time)}</td>
                <td>{transaction.payment_razor_pay_id || 'Pending'}</td>
                <td>{transaction.payment_status}</td>
                <td>
                  <ul className="books-list">
                    {transaction.books.map((book) => (
                      <li key={book.book_id}>{book.book_name} ({book.book_type})</li>
                    ))}
                  </ul>
                </td>
                <td>
                  {transaction.books.reduce((total, book) => total + book.quantity, 0)}
                </td>
                <td>₹{transaction.paid_amount}</td>
                <td>{formatAddress(transaction.address)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  };

  return renderTable();
};

export default OrderPage;